<template>
  <div>
    <v-card>
      <v-alert v-if="record.actualizado" dark color="warning"
        >Registro Actualizado</v-alert
      >
      <v-alert v-if="record.nuevo" dark color="success"
        >Registro Creado</v-alert
      >
      <v-card-title>
        Turno de Examen
        <v-btn link icon absolute top right @click="cerrar"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-autocomplete
            v-if="!model.id"
            outlined
            v-model="carrerasSeleccionadas"
            :items="carreras"
            item-text="nombre"
            item-value="id"
            label="Carreras"
            multiple
            chips
            deletable-chips
            :error-messages="errors.carrera_id"
          ></v-autocomplete>
          <v-select
            v-else
            outlined
            v-model="model.carrera_id"
            :items="carreras"
            item-text="nombre"
            item-value="id"
            label="Carrera"
            :error-messages="errors.carrera_id"
          ></v-select>

          <v-text-field
            outlined
            v-model="model.nombre"
            label="Nombre"
            :error-messages="errors.nombre"
          ></v-text-field>

          <v-select
            outlined
            v-model="model.tipo"
            :items="tipoOptions"
            label="Tipo"
            :error-messages="errors.tipo"
          ></v-select>

          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                type="number"
                v-model="model.anio"
                label="Anio"
                :error-messages="errors.anio"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                outlined
                v-model="model.mes"
                :items="mesOptions"
                label="Mes"
                :error-messages="errors.mes"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.fecha_inicio_inscripcion"
                label="Fecha Inicio Inscripcion"
                :error-messages="errors.fecha_inicio_inscripcion"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                type="date"
                v-model="model.fecha_fin_inscripcion"
                label="Fecha Fin Inscripcion"
                :error-messages="errors.fecha_fin_inscripcion"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                v-model="model.pdf_turno"
                label="PDF Turno (URL)"
                :error-messages="errors.pdf_turno"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                v-model="model.pdf_horarios_consulta"
                label="PDF Horarios Consulta (URL)"
                :error-messages="errors.pdf_horarios_consulta"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-textarea
            outlined
            v-model="model.aclaracion_turno"
            label="Aclaracion Turno"
            rows="3"
            :error-messages="errors.aclaracion_turno"
          ></v-textarea>

          <v-textarea
            outlined
            v-model="model.aclaracion_turno_2"
            label="Aclaracion Turno 2"
            rows="3"
            :error-messages="errors.aclaracion_turno_2"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn @click="guardar" color="primary">Guardar</v-btn>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-btn @click="cerrar">Cancelar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "TurnoExamenForm",
  props: {
    id: [String, Number],
  },
  data() {
    return {
      model: {
        tipo: "regular",
        anio: new Date().getFullYear(),
        mes: null,
        carrera_id: null,
      },
      carrerasSeleccionadas: [],
      tipoOptions: [
        { text: "Regular", value: "regular" },
        { text: "Extraordinaria", value: "extraordinaria" },
      ],
      mesOptions: [
        { text: "Enero", value: 1 },
        { text: "Febrero", value: 2 },
        { text: "Marzo", value: 3 },
        { text: "Abril", value: 4 },
        { text: "Mayo", value: 5 },
        { text: "Junio", value: 6 },
        { text: "Julio", value: 7 },
        { text: "Agosto", value: 8 },
        { text: "Septiembre", value: 9 },
        { text: "Octubre", value: 10 },
        { text: "Noviembre", value: 11 },
        { text: "Diciembre", value: 12 },
      ],
    };
  },
  computed: {
    ...mapGetters("TurnoExamenModule", ["errors"]),
    ...mapState("TurnoExamenModule", ["fields", "turnoExamen", "record"]),
    ...mapState("CarreraModule", ["carreras"]),
  },
  methods: {
    ...mapActions("TurnoExamenModule", [
      "getFields",
      "getTurnoExamen",
      "updateTurnoExamen",
      "addTurnoExamen",
    ]),
    ...mapActions("CarreraModule", ["getCarreras"]),

    async getModel() {
      await this.getTurnoExamen(this.id);
      this.model = { ...this.turnoExamen };
    },

    async guardar() {
      if (this.model.id) {
        // Edicion: actualizar solo el turno existente
        await this.updateTurnoExamen(this.model);
      } else {
        // Nuevo: crear un turno por cada carrera seleccionada
        for (const carreraId of this.carrerasSeleccionadas) {
          const turnoData = {
            ...this.model,
            carrera_id: carreraId,
          };
          await this.addTurnoExamen(turnoData);
        }
      }
    },

    cerrar() {
      this.record.actualizado = false;
      this.record.nuevo = false;
      this.$emit("close");
    },
  },
  watch: {
    id() {
      if (this.id) {
        this.getModel();
      }
    },
  },
  created() {
    this.getFields();
    this.getCarreras();
    if (this.id) {
      this.getModel();
    }
  },
};
</script>

<style scoped></style>
